import { InfinityIcon } from "@xola/icons";
import clsx from "clsx";
import React from "react";
import { OPEN_UNLIMITED, Timeslot } from "types";
import { NoTranslate } from "../../Common/NoTranslate";
import { getBookedCount, getOpenCapacity } from "@/models/Timeslot";

export const CollapsedTimeslotDisplay = ({ timeslot }: { timeslot: Timeslot }) => {
    const available = getOpenCapacity(timeslot);
    const reserved = getBookedCount(timeslot);
    const color = getTextColorByAvailability(available, reserved);

    return (
        <span className={clsx("flex flex-col items-center justify-center px-2")}>
            <NoTranslate as="div" className={clsx("ui-dashboard-available text-md font-bold", color)}>
                {available >= OPEN_UNLIMITED ? (
                    <InfinityIcon data-testid="ui-dashboard-infinity-icon" size="large" />
                ) : (
                    available
                )}
            </NoTranslate>

            <div className="text-sm font-bold">Available</div>
            <div className="text-xs">
                <var data-var="reservedCount">{reserved}</var> Reserved
            </div>
        </span>
    );
};

const getTextColorByAvailability = (available: number, reserved: number) => {
    if (available <= 0) {
        return "text-danger";
    }

    return available > reserved ? "text-success" : "text-warning";
};
